export enum EventCategory {
  Theatre = 1,
  Music = 2,
  Sports = 3,
  Dance = 4,
  Conference = 5,
  Cinemas = 6,
  Happenings = 12,
  Expedition = 15,
  Seminar = 19,
  Museums = 20,
  StandUpComedy = 23,
  Subscriptions = 39,
  Workshop = 40,
}
